// extracted by mini-css-extract-plugin
export default {"container":"PopupV1_container__kzcxL","overlay":"PopupV1_overlay__bJzl4","form":"PopupV1_form__+QLW8"};